import prdimg1 from '../../images/icon/document.svg'
import prdimg2 from '../../images/icon/bar-graph.svg'
import prdimg3 from '../../images/icon/clipboard.svg'

export   const featres = [
         {
            fIcon:prdimg1,
            title:'People at the Heart of Growth',
            des:'Creating a workplace where people thrive, innovate, and drive your business forward.',      
            // link:'/service-single',
         },
         {
            fIcon:prdimg2,
            title:'Compliance Without Complexity',
            des:'Ensuring your business stays protected while your employees feel valued.',      
            // link:'/service-single',
         },
         {
            fIcon:prdimg3,
            title:'Building Workplaces That Inspire',
            des:'Shape a culture where talent stays, performance grows, and success follows.',      
            // link:'/service-single',
         },
         
     ]